import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { RuleOperationType } from '@src/api';
import { theme } from '@src/theme';
import { FC, useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import { DisableContext } from '../DisableContext';
import { buildDataTestIdAttribute, buildDataTestIdFromNestedName } from '@src/utils';

const border = `1px solid ${theme.palette.secondary['500']}`;

const borderDisabled = `1px solid ${theme.palette.secondary['400']}`;

const DisabledOperation = ({ operation }) => {
  return operation === RuleOperationType.And ? (
    <Box padding="6px 24px" borderLeft={borderDisabled} borderRight={borderDisabled}>
      <Box
        padding="0 3px"
        border={borderDisabled}
        width="min-content"
        sx={{ background: theme.palette.secondary['200'] }}
      >
        <Typography color="secondary" fontWeight={700} fontSize="10px" lineHeight="18px" textTransform="uppercase">
          {RuleOperationType.And}
        </Typography>
      </Box>
    </Box>
  ) : (
    <Box sx={{ transform: 'translate(0, -14px)', zIndex: 100, height: 0 }}>
      <Box
        margin="6px 24px"
        padding="0 3px"
        border={borderDisabled}
        width="min-content"
        sx={{ background: theme.palette.secondary['200'] }}
      >
        <Typography color="secondary" fontWeight={700} fontSize="10px" lineHeight="18px" textTransform="uppercase">
          {RuleOperationType.Or}
        </Typography>
      </Box>
    </Box>
  );
};

type OperationBetweenRulesProps = {
  prefix: string;
  ruleGroup: any;
};

export const OperationBetweenRules: FC<OperationBetweenRulesProps> = ({ prefix }) => {
  const { setValue, watch } = useFormContext();
  const disabled = useContext(DisableContext);

  const operation = watch(prefix);

  const dataTestId = buildDataTestIdFromNestedName(prefix, 'button');

  const handleChange = (_e: any, value: RuleOperationType) => {
    if (!value) return;
    setValue(prefix, value);
  };
  const borderOperation = disabled ? `1px solid ${theme.palette.grey['300']}` : border;
  return operation ? (
    disabled ? (
      <DisabledOperation operation={operation} />
    ) : (
      <Box
        padding="12px 24px"
        borderLeft={borderOperation}
        borderRight={borderOperation}
        bgcolor={disabled ? theme.palette.grey['200'] : theme.palette.secondary['100']}
      >
        <ToggleButtonGroup
          value={operation}
          exclusive
          onChange={handleChange}
          size="small"
          sx={{ height: '24px' }}
          disabled={disabled}
        >
          <ToggleButton
            disabled={disabled}
            value={RuleOperationType.And}
            {...buildDataTestIdAttribute(`${dataTestId}-and`)}
          >
            And
          </ToggleButton>
          <ToggleButton
            disabled={disabled}
            value={RuleOperationType.Or}
            {...buildDataTestIdAttribute(`${dataTestId}-or`)}
          >
            Or
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    )
  ) : null;
};
